import { useEffect, useState, type FormEvent, type ReactNode } from "react";
import { PrecisionIcon } from "./PrecisionIcon";
import { apiUrl } from "../lib/accountApi";

const developerPath = typeof window !== "undefined" && location.pathname.replace(/\/+$/, "") === "/developer";
const workshopPath = typeof window !== "undefined" && location.pathname.replace(/\/+$/, "") === "/workshop";
const requested = typeof window !== "undefined" && (developerPath || workshopPath || new URL(location.href).searchParams.get("demo") === "1");
const developerApi = String(import.meta.env.VITE_API_BASE_URL || "").replace(/\/$/, "");
const developerTokenKey = "precisionEV.developerToken";

export function DeveloperGate({ children }: { children: ReactNode }) {
  const [authorized, setAuthorized] = useState(!requested);
  const [checking, setChecking] = useState(requested);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!requested) return;
    document.querySelector('meta[name="robots"]')?.remove();
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex,nofollow,noarchive";
    document.head.appendChild(robots);
    const token = sessionStorage.getItem(developerTokenKey) || "";
    if (!token) { setAuthorized(import.meta.env.DEV && sessionStorage.getItem("precisionEV.localDeveloper") === "1"); setChecking(false); return; }
    void fetch(apiUrl(developerApi,"/api/v1/developer/session"), { cache: "no-store", headers: { authorization: `Bearer ${token}` } }).then((response) => response.ok ? response.json() : { authorized: false }).then((result: { authorized?: boolean }) => {
      const localAccess = import.meta.env.DEV && sessionStorage.getItem("precisionEV.localDeveloper") === "1";
      setAuthorized(Boolean(result.authorized || localAccess));
      if (!result.authorized) sessionStorage.removeItem(developerTokenKey);
      setChecking(false);
    }).catch(() => { sessionStorage.removeItem(developerTokenKey); setAuthorized(import.meta.env.DEV && sessionStorage.getItem("precisionEV.localDeveloper") === "1"); setChecking(false); });
  }, []);

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (!password || busy) return;
    setBusy(true); setError("");
    if (import.meta.env.DEV && password === "local-demo") {
      sessionStorage.setItem("precisionEV.localDeveloper", "1");
      setAuthorized(true); setChecking(false); setBusy(false); return;
    }
    try {
      const response = await fetch(apiUrl(developerApi,"/api/v1/developer/session"), { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ password }) });
      if (response.status === 429 || response.status === 503) throw new Error("API_UNAVAILABLE");
      if (!response.ok) throw new Error("INVALID");
      const result = await response.json() as { token?: string };
      if (!result.token) throw new Error("INVALID");
      sessionStorage.setItem(developerTokenKey, result.token);
      if (!developerPath && !workshopPath) history.replaceState(null, "", "/developer");
      setAuthorized(true);
    } catch (problem) {
      setError(problem instanceof Error && problem.message === "API_UNAVAILABLE" ? "O servidor privado não está disponível neste momento." : "Acesso inválido. Verifique a palavra-passe developer.");
    }
    finally { setBusy(false); }
  }

  if (!requested || authorized) return children;
  return <main className="developer-access-screen"><section className="developer-access-card"><span className="developer-access-icon"><PrecisionIcon name="lock" /></span><small>PRECISION EV</small><h1>Área privada de desenvolvimento</h1><p>Esta versão contém apenas dados fictícios e ferramentas de simulação. O acesso é reservado ao proprietário.</p>{checking ? <div className="developer-access-loading">A validar a sessão segura…</div> : <form onSubmit={submit}><label>Palavra-passe developer<input autoFocus type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} /></label>{error && <p className="developer-access-error">{error}</p>}<button disabled={busy || !password}>{busy ? "A validar…" : "Entrar no modo developer"}</button></form>}<a href="/">Voltar à aplicação normal</a></section></main>;
}
